var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7130_10380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.8775L14.6225 12H3.5V3H15.5V12.8775ZM15.5 1.5H3.5C2.675 1.5 2 2.175 2 3V12C2 12.825 2.675 13.5 3.5 13.5H14L17 16.5V3C17 2.175 16.325 1.5 15.5 1.5Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 3,
    r: 2.9,
    fill: "#FF9831"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7130_10380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsCircle);
export default __webpack_public_path__ + "static/media/comments-circle.bc386dbd480c9b73f70be259971f9e2c.svg";
export { ForwardRef as ReactComponent };